<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>{{ state.title }}</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createNew">
                Add Subject
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        label="Remove"
                        icon="pi pi-trash"
                        class="p-button-rounded p-button-text"
                        @click="remove(slotProps.data)"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="addSubjects"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRoute } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";

export default {
    name:"AcademicYear",
    components:{ModalView,DynamicForm},
    setup(){
        const route = useRoute();
        const id = computed(() => route.params.id)
        const state=reactive({loading:true,createModal:false,title:"Subjects",
            submitting:false,error:[],success:false,
        })
        const subjects=ref([])
        const list = ref([])
        const globalFilter=ref("")
        const createFields=ref([
            { name: "Add Subject", number: "1",data: 
                    [
                        { type: 'checkbox', name: 'subject', label: 'Subjects',
                            value:"",values:subjects },
                    ]
                }
        ])

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        function addSubjects(data){
            state.submitting=true;
            state.errors=[];
            data.addTeacherSubject=id.value;
            state.success=false;
            call({
                url:urls.teachers,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function remove(row){
            var v=confirm("Are you sure you want to remove this subject from this teacher?");
            if(!v){return;}
            state.loading=true
            call({
                url:urls.teachers,
                data:{removeSubject:row.id},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        }
        onMounted(() => {
            call({
                url:urls.teachers,
                data:{getTeachersSubject:id.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                        state.title=res.msg.title;
                        subjects.value=[];
                        Object.keys(res.msg.sub).forEach(k => {
                            subjects.value.push(res.msg.sub[k])
                        })
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function createNew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
        }
        
        return {list,globalFilter, state,createFields,addSubjects,createNew,
        remove}
    }
}
</script>